import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type { ContentSectionConfig } from "../../@types/portalAluno";
import { getContentTags } from "../../services/portalAluno/tags/tagsService";
import type { ApplicationState } from "../../store";

export const portalTagsQueryKey = (idUsuario?: number) => [
  "portal-aluno",
  "tags",
  idUsuario,
];

const useContentTags = (section?: ContentSectionConfig) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery<string[]>({
    enabled: Boolean(idUsuario && section?.tagFiltered),
    queryKey: portalTagsQueryKey(idUsuario),
    queryFn: () => getContentTags(),
    staleTime: 30 * 1000,
  });
};

export default useContentTags;
